import { Address } from '@dsivd/prestations-ng';

import { CadorReference } from './cador-reference';

export class Personne {
    internalReference: string;
    isDemandeur = false;
    role: CadorReference;
    nom: string;
    prenom: string;
    adresse: Address;
    email: string;
    telephone: string;
}
